import React from 'react';
import { FOOTER_COPY } from '../copy';
import s from '../s.module.less';

type Props = {
    persona: 'managed' | 'manual';
    skipCostModal: boolean;
    // 不收费的卡（PAYER_DOWN / SYSTEM_ERROR）传整句替代 chip；仍仅 manual 渲染
    freeText?: string;
};

// 本次 check 的计费结果，且只讲这一件事。后端口径：SYSTEM_ERROR / PAYER_DOWN 不收费，其余都收。
// managed 全程无计费文案（给免费用户报免费是噪音）；manual 的 "+$0.25" chip 只在 cost modal
// 被关掉后出现（否则它是第三遍重复）；no-charge 整句不受 skip 门槛限制（它不是价格的重复）
const BillingFooter: React.FC<Props> = ({ persona, skipCostModal, freeText }) => {
    if (persona === 'managed') {
        return null;
    }
    if (freeText) {
        return <div className={s.billingFoot}>{freeText}</div>;
    }
    if (!skipCostModal) {
        return null;
    }
    return (
        <div className={s.billingFoot}>
            <span className={s.billChip}>{FOOTER_COPY.charged}</span>
        </div>
    );
};

export default BillingFooter;
